import type * as BackendTypes from 'chaika-types';
import { OptionalAsNotRequired, DatesAsString, Nullable, StringArrayAsString } from 'chaika-common-types';

export interface TaskListResponse
    extends Omit<OptionalAsNotRequired<DatesAsString<BackendTypes.TaskListResponse>>, 'tasks'> {
    tasks: TaskData[];
}

export interface TaskData extends OptionalAsNotRequired<DatesAsString<BackendTypes.TaskViewModel>> {}
export interface TaskListQuery extends StringArrayAsString<DatesAsString<BackendTypes.TaskListQuery>> {}

export interface TaskCreationForm extends BackendTypes.TaskCreationForm {}
export interface TaskCreationParams extends OptionalAsNotRequired<DatesAsString<BackendTypes.TaskCreationParams>> {}

export interface TaskUpdateForm extends BackendTypes.TaskUpdatingForm {}
export interface TaskUpdateParams
    extends Omit<OptionalAsNotRequired<DatesAsString<BackendTypes.TaskUpdatingParams>>, 'medicalCaseIds'> {
    medicalCaseIds?: Nullable<string[]>;
}

export interface TaskStatusChangingForm extends BackendTypes.TaskStatusChangingForm {}
export interface TaskStatusChangingParams extends BackendTypes.TaskStatusChangingParams {}

export const enum FrontendTaskStatus {
    Draft = 'draft',
}

export { TaskRepetitionPeriod, TaskStatus, TaskUrgency } from 'chaika-enums';
